"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DirectionStepIcon = DirectionStepIcon;
var _SvgIcon2 = _interopRequireDefault(require("@mui/material/SvgIcon"));
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function DirectionStepIcon(props) {
  return /*#__PURE__*/_react.default.createElement(_SvgIcon2.default, _extends({
    viewBox: "0 0 10 13"
  }, props), /*#__PURE__*/_react.default.createElement("path", {
    d: "M1.59729 11.983V1.35217L8.60492 5.32584L1.59729 8.88666",
    stroke: "currentColor",
    strokeMiterlimit: "10"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M0 11.983H3.14313",
    stroke: "currentColor",
    strokeMiterlimit: "10"
  }));
}